<template>
  <div>
    <SelectItems
      class="mb-7"
      :items="itemSelect"
      :defaultData="itemSelect[0]"
      label="Chọn model"
      entity="productModels"
      @changeItem="v => (info.productModel = v)"
    />
    <v-text-field
      dense
      label="Mã IMEI/ Mã Seria"
      v-model="info.imei"
      :rules="[$rules.required]"
      class="required"
      outlined
    ></v-text-field>
    <v-text-field
      dense
      label="Mã hóa đơn"
      v-model="info.billCode"
      :rules="[$rules.required]"
      class="required"
      outlined
    ></v-text-field>
    <v-text-field dense label="Mã phiếu / DO" v-model="info.doCode" outlined></v-text-field>
    <v-text-field dense label="Mã đơn / PO" v-model="info.poCode" outlined hide-details></v-text-field>
    <v-radio-group v-model="info.status" row>
      <v-radio class="align-left" label="Xác nhận nhập" value="approve" />
      <v-radio class="align-left" :label="$slots.label" value="reject">
        <template v-slot:label>
          <span>Xác nhận <span class="text-red"> không </span> nhập</span>
        </template>
      </v-radio>
    </v-radio-group>
    <v-autocomplete
      dense
      :items="items"
      @change="v => (info.productState = v)"
      label="Tình trạng hàng"
      :value="info.productState"
      outlined
    ></v-autocomplete>
    <div class="pb-4">
      <div class="image-input" :style="{ 'background-image': `url(${info.image})` }" @click="chooseImage">
        <v-btn icon v-if="info.image" class="d-flex float-right">
          <v-icon color="black" @click="removeImage">close</v-icon>
        </v-btn>
        <span v-if="!info.image" class="placeholder"> Tải ảnh lên </span>
        <input
          class="file-input"
          ref="fileInput"
          type="file"
          accept="image/png, image/jpeg, image/bmp"
          @input="onChange"
        />
      </div>
    </div>
    <v-textarea outlined full-width name="input-7-3" label="Ghi chú" rows="2" v-model="info.notes" dense></v-textarea>
    <Confirm
      ref="confirmCheckBillCode"
      @option1="() => save({ ...dataUpdate, reset: false })"
      @option2="openPickBillCode"
    />
    <PickBillCode ref="pickBillCode" @accept="confirmPickBillCode" />
  </div>
</template>
<script>
import SelectItems from '@/components/samnec/SelectItems.vue'
import PickBillCode from './PickBillCode.vue'
import Confirm from '@/components/plugin/Confirm.vue'
import { get } from 'lodash'
import { mapActions } from 'vuex'
import api from '@/plugins/api'
export default {
  props: {
    auditProduct: {
      type: Object,
      default: () => ({})
    }
  },
  components: { SelectItems, Confirm, PickBillCode },
  data() {
    return {
      dialog: false,
      info: {
        productModel: '',
        imei: '',
        billCode: '',
        doCode: '',
        poCode: '',
        status: '',
        productState: [],
        image: null,
        notes: ''
      },
      dataUpdate: {},
      itemSelect: [],
      items: [
        { text: 'Vỏ hộp không đạt yêu cầu (bẹp, méo, rách, xước, ngấm nước, ..', value: 'container' },
        { text: 'Phụ kiện / Bộ phận sản phẩm đi kèm không đầy đủ', value: 'attachment' },
        { text: 'Mã IMEI / Serial không có trong danh sách', value: 'imeiNotFound' },
        { text: 'Nội dung / Lý do khác', value: 'other' }
      ]
    }
  },
  created() {
    this.handleData()
  },
  methods: {
    ...mapActions({
      upload: 'upload/upload',
      destroy: 'upload/destroy',
      countItems: 'importDeliveryProduct/countItems',
      updateItem: 'importDeliveryProduct/updateItem'
    }),
    chooseImage() {
      this.$refs.fileInput.click()
    },
    reset() {
      this.$refs.form.reset()
      this.removeImage()
    },
    onChange() {
      const input = this.$refs.fileInput
      const files = input.files
      if (files && files.length) {
        const reader = new FileReader()
        reader.onload = e => {
          this.info.image = e.target.result
        }
        reader.readAsDataURL(files[0])
        this.info.image = files[0]
      }
    },
    async getData() {
      const imageFiles = this.$refs['fileInput'].files
      if (imageFiles.length) {
        let formData = new FormData()
        formData.append('files', imageFiles[0])
        formData.append('field', 'image')
        const res = await this.upload(formData)
        this.info.image = res
      }
      if (!this.info.productModel || !this.info.imei || !this.info.billCode || !this.info.status) {
        this.$alert.error('Vui lòng nhập đầy đủ dữ liệu')
        return null
      }
      return {
        ...this.info
      }
    },
    confirmPickBillCode(billCode) {
      this.dataUpdate.billCode = billCode
      this.dataUpdate.reset = false
      this.save(this.dataUpdate)
    },
    async onSave() {
      try {
        this.$loading.active = true
        const data = await this.getData()
        this.dataUpdate = data
        const products = await api['ImportDeliveryProduct'].fetch({ importCheck: this.$route.params.id, _limit: -1 })
        const countBill = []
        products.forEach(product => {
          if (product.billCode !== null || product.billCode !== '') {
            countBill.push(product)
          }
        })
        if (countBill.length === 0) {
          await this.save(data)
        }
        if (countBill.length > 0) {
          const existBill = products.find(product => product.billCode === data.billCode)
          if (existBill) {
            await this.save(data)
          } else {
            this.$loading.active = false
            this.$refs.confirmCheckBillCode.show({
              title: 'Bổ sung mã hoá đơn mới?',
              message:
                'Mã hoá đơn bạn nhập không trùng với (các) mã hoá đơn đang có. Bạn có muốn tạo hoá đơn mới không?',
              ok1Text: 'Có, tạo mới',
              ok2Text: 'Không, dùng mã hoá đơn cũ',
              cancelText: 'Huỷ',
              data
            })
          }
        }
      } finally {
        this.$loading.active = false
      }
    },
    async openPickBillCode() {
      this.$refs.pickBillCode.openDialog(this.$route.params.id)
    },
    async save(data) {
      try {
        this.$loading.active = true
        await this.updateItem({ id: this.info.productModel, ...data })
        this.$alert.success('Cập nhật thành công')
        this.$emit('refresh')
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    removeImage() {
      this.info.image = null
    },
    handleData() {
      if (this.auditProduct) {
        this.info.productModel = get(this.auditProduct, 'id', '')
        this.info.imei = get(this.auditProduct, 'imei', '')
        this.info.billCode = get(this.auditProduct, 'billCode', '')
        this.info.doCode = get(this.auditProduct, 'doCode', '')
        this.info.poCode = get(this.auditProduct, 'poCode', '')
        this.info.status = get(this.auditProduct, 'status', '')
        this.info.productState = get(this.auditProduct, 'productState', '')
        this.info.image = get(this.auditProduct, 'image.url', null)
        this.info.notes = get(this.auditProduct, 'notes', '')
        this.itemSelect = [
          {
            text: `${this.auditProduct.code} / ${this.auditProduct.description}`,
            value: this.auditProduct.id
          }
        ]
      }
    }
  }
}
</script>
<style scoped>
.image-input {
  display: block;
  width: 200px;
  height: 200px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}

.text-red {
  color: red;
}

.placeholder {
  background: #f0f0f0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
  font-family: Helvetica;
}

.placeholder:hover {
  background: #e0e0e0;
}

.file-input {
  display: none;
}
</style>
